import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Section";
import { SEO } from "@/seo/useSeo";

const BLURB = {
  "/lawn-mowing-app": "Every property, every mow: before and after photos, gate codes and crew hours.",
  "/cleaning-business-app": "Check-ins at every site, day or night, and photo proof for every clean.",
  "/painting-plastering-app": "Room-by-room photos, site cleans, deliveries and reports for builders.",
};

// Home band linking to the industry landing pages.
export const Industries = () => (
  <section className="bg-white py-20 lg:py-24" data-testid="home-industries">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="font-mono text-xs font-semibold tracking-[0.2em] uppercase text-[#EA580C]">Who it&apos;s for</p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight max-w-2xl">Built for trade and service crews that work on client sites.</h2>
        </div>
        <p className="text-sm text-slate-600 max-w-sm">Plus electricians, plumbers, handymen and any crew whose work needs to be on record.</p>
      </div>
      <div className="mt-10 grid md:grid-cols-3 gap-5">
        {SEO.site.industries.map(([path, label], i) => (
          <Reveal key={path} delay={0.06 * i}>
            <Link to={path} data-testid={`home-industry-${SEO.pages[path].slug}`}
              className="group block rounded-2xl overflow-hidden border border-slate-200 bg-[#F8FAFC] hover:border-[#EA580C] transition-colors">
              <div className="aspect-[16/10] overflow-hidden">
                <img src={SEO.pages[path].media.hero} alt={SEO.pages[path].media.heroAlt} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-6">
                <p className="font-display text-lg font-bold flex items-center justify-between gap-3">{label}
                  <ArrowUpRight className="w-5 h-5 text-[#EA580C] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></p>
                <p className="mt-2 text-sm text-slate-600">{BLURB[path]}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
